import styles from "./styles.module.css";

export default PageContact;

function PageContact() {
   return <div>
      <div className={styles.header}>
         Contact
      </div>
      <div className={styles.body}>
         userh309.real@gmail.com
      </div>
   </div>;
}
